export default __webpack_public_path__ + "static/media/k_title.21fbdeb1.jpg";